import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Check, Copy, Sparkles } from 'lucide-react'
import { toast } from 'sonner'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'

const MCP_URL = `${import.meta.env.VITE_MOLY_API}/mcp`

export function McpSetupCard() {
  const { t } = useTranslation('settings')
  const [copied, setCopied] = useState(false)

  const configJson = useMemo(
    () =>
      JSON.stringify(
        {
          mcpServers: {
            moly: {
              url: MCP_URL,
              headers: { Authorization: 'Bearer mp_...' },
            },
          },
        },
        null,
        2,
      ),
    [],
  )

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(configJson)
      setCopied(true)
      toast.success(t('integrationsPage.mcp.copied'))
      setTimeout(() => setCopied(false), 2000)
    } catch {
      toast.error(t('integrationsPage.mcp.copied'))
    }
  }

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Sparkles className="size-4 text-muted-foreground" />
          <CardTitle>{t('integrationsPage.mcp.title')}</CardTitle>
        </div>
        <CardDescription>
          {t('integrationsPage.mcp.description')}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-center justify-between gap-2">
          <p className="text-sm font-medium">
            {t('integrationsPage.mcp.configLabel')}
          </p>
          <Button variant="outline" size="sm" onClick={handleCopy}>
            {copied ? (
              <Check className="size-4 mr-1" />
            ) : (
              <Copy className="size-4 mr-1" />
            )}
            {copied
              ? t('integrationsPage.mcp.copied')
              : t('integrationsPage.mcp.copyConfig')}
          </Button>
        </div>
        <pre className="rounded border border-input bg-muted px-4 py-3 text-xs font-mono overflow-x-auto">
          {configJson}
        </pre>
        <p className="text-xs text-muted-foreground">
          {t('integrationsPage.mcp.tokenPlaceholderHint')}
        </p>
        <p className="text-xs text-muted-foreground">
          {t('integrationsPage.mcp.rateLimitNote')}
        </p>
      </CardContent>
    </Card>
  )
}
